import React, { memo, FocusEvent, useCallback } from "react";
import { Field } from "react-final-form";
import { InputText } from "../input-text/input-text";
import { IFinalFormInputTextProps } from "./interfaces";

export const FinalFormInputText = memo(
  ({
    name,
    label,
    id,
    status,
    isFullWidth,
    isMultiline,
    isDisabled,
    helperText,
    rows,
    startAdornment,
    className,
    validate,
    onFocus,
    onBlur,
  }: IFinalFormInputTextProps) => {
    return (
      <Field
        name={name}
        validate={validate}
        render={({ input }) => {
          const handleFocus = useCallback(
            (evt: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
              onFocus && onFocus(evt);
              input.onFocus(evt);
            },
            [input]
          );

          const handleBlur = useCallback(
            (evt: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
              onBlur && onBlur(evt);
              input.onBlur(evt);
            },
            [input]
          );

          return (
            <InputText
              {...input}
              status={status}
              id={id}
              label={label}
              rows={rows}
              helperText={helperText}
              isFullWidth={isFullWidth}
              isMultiline={isMultiline}
              isDisabled={isDisabled}
              startAdornment={startAdornment}
              className={className}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          );
        }}
      />
    );
  }
);
